import React, { useState } from 'react';
import { SummaryCharts } from './SummaryStyles';
import { SummaryChart } from './SummaryChart/SummaryChart';
import { useIsEmbeddedMobile } from '../../_hooks/useIsEmbeddedMobile';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { SimpleTab } from '../../CommonComponents/OPL/Tab/SimpleTab';

export const SummaryEmpty = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <>
      {isEmbeddedMobile ? (
        <>
          <Box display="flex" mx="12" mt="24">
            <SimpleTab
              isActive={selectedIndex === 0}
              onClick={() => setSelectedIndex(0)}
              style={{ width: '50%' }}
            >
              Current Scenario
            </SimpleTab>
            <SimpleTab
              isActive={selectedIndex === 1}
              onClick={() => setSelectedIndex(1)}
              color="neutral.500"
              style={{ width: '50%' }}
            >
              Recommended
            </SimpleTab>
          </Box>
          <SummaryCharts>
            <SummaryChart />
          </SummaryCharts>
        </>
      ) : (
        <SummaryCharts>
          <SummaryChart title="Current Scenario" />
          <SummaryChart title="Recommended Scenario" />
        </SummaryCharts>
      )}
    </>
  );
};
